import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={960} height={12} fill='none' {...props}>
    <path
      fill='#D1D4DC'
      d='M0 6a6 6 0 0 1 6-6h287v12H6a6 6 0 0 1-6-6M297 0h657a6 6 0 1 1 0 12H297z'
      opacity={0.8}
    />
  </svg>
);
export default SvgBar;
